export const statusCodes = {
  ACCESS_DENIED_OPERATION: 448,
};
